import { COUNTRY_NAME } from 'modules/country/constants/name'
import {
  invertObjectUtil,
  omitObjectUtil
} from 'packages/src'

/**
 * A mapping of country to iso country code.
 * @type {Object}
 */
const COUNTRY_CODE = {
  [COUNTRY_NAME.AFGHANISTAN]: 'AF',
  [COUNTRY_NAME.ALAND_ISLANDS]: 'AX',
  [COUNTRY_NAME.ALBANIA]: 'AL',
  [COUNTRY_NAME.ALGERIA]: 'DZ',
  [COUNTRY_NAME.AMERICAN_SAMOA]: 'USAS',
  [COUNTRY_NAME.ANDORRA]: 'AD',
  [COUNTRY_NAME.ANGOLA]: 'AO',
  [COUNTRY_NAME.ANGUILLA]: 'AI',
  [COUNTRY_NAME.ANTARCTICA]: 'AQ',
  [COUNTRY_NAME.ANTIGUA_BARBUDA]: 'AG',
  [COUNTRY_NAME.ARGENTINA]: 'AR',
  [COUNTRY_NAME.ARMENIA]: 'AM',
  [COUNTRY_NAME.ARUBA]: 'AW',
  [COUNTRY_NAME.ASCENSION]: 'AC',
  [COUNTRY_NAME.AUSTRALIA]: 'AU',
  [COUNTRY_NAME.AUSTRIA]: 'AT',
  [COUNTRY_NAME.AZERBAIJAN]: 'AZ',
  [COUNTRY_NAME.AZORES]: 'PT',
  [COUNTRY_NAME.BAHAMAS]: 'BS',
  [COUNTRY_NAME.BAHRAIN]: 'BH',
  [COUNTRY_NAME.BALEARIC_ISLANDS]: 'ES',
  [COUNTRY_NAME.BANGLADESH]: 'BD',
  [COUNTRY_NAME.BARBADOS]: 'BB',
  [COUNTRY_NAME.BELARUS]: 'BY',
  [COUNTRY_NAME.BELGIUM]: 'BE',
  [COUNTRY_NAME.BELIZE]: 'BZ',
  [COUNTRY_NAME.BENIN]: 'BJ',
  [COUNTRY_NAME.BERMUDA]: 'BM',
  [COUNTRY_NAME.BES_ISLANDS]: 'BQ',
  [COUNTRY_NAME.BHUTAN]: 'BT',
  [COUNTRY_NAME.BOLIVIA]: 'BO',
  [COUNTRY_NAME.BONAIRE]: 'BQ',
  [COUNTRY_NAME.BOSNIA_HERZ]: 'BA',
  [COUNTRY_NAME.BOTSWANA]: 'BW',
  [COUNTRY_NAME.BOUVET_ISLAND]: 'BV',
  [COUNTRY_NAME.BRAZIL]: 'BR',
  [COUNTRY_NAME.BRUNEI]: 'BN',
  [COUNTRY_NAME.BR_IND_OCEAN_TR]: 'IO',
  [COUNTRY_NAME.BR_VIRGIN_ISL]: 'VG',
  [COUNTRY_NAME.BULGARIA]: 'BG',
  [COUNTRY_NAME.BURKINA_FASO]: 'BF',
  [COUNTRY_NAME.BURMA]: 'MM',
  [COUNTRY_NAME.BURUNDI]: 'BI',
  [COUNTRY_NAME.CAMBODIA]: 'KH',
  [COUNTRY_NAME.CAMEROON]: 'CM',
  [COUNTRY_NAME.CANARY_ISLANDS]: 'ES',
  [COUNTRY_NAME.CANADA]: 'CA',
  [COUNTRY_NAME.CAPE_VERDE]: 'CV',
  [COUNTRY_NAME.CAYMAN_ISLANDS]: 'KY',
  [COUNTRY_NAME.CENTRAL_AFRICAN_REPUBLIC]: 'CF',
  [COUNTRY_NAME.CHAD]: 'TD',
  [COUNTRY_NAME.CHANNEL_ISLANDS]: 'GB',
  [COUNTRY_NAME.CHILE]: 'CL',
  [COUNTRY_NAME.CHINA]: 'CN',
  [COUNTRY_NAME.CHRISTMAS_ISLAND]: 'CX',
  [COUNTRY_NAME.COCOS_ISLANDS]: 'CC',
  [COUNTRY_NAME.COLOMBIA]: 'CO',
  [COUNTRY_NAME.COMOROS]: 'KM',
  [COUNTRY_NAME.CONGO]: 'CG',
  [COUNTRY_NAME.CONGO_DEMOCRATIC_REPUBLIC]: 'CD',
  [COUNTRY_NAME.COOK_ISLANDS]: 'CK',
  [COUNTRY_NAME.CORSICA]: 'FR',
  [COUNTRY_NAME.COSTA_RICA]: 'CR',
  [COUNTRY_NAME.COTE_D_IVOIRE]: 'CI',
  [COUNTRY_NAME.CROATIA]: 'HR',
  [COUNTRY_NAME.CUBA]: 'CU',
  [COUNTRY_NAME.CURACAO]: 'CW',
  [COUNTRY_NAME.CYPRUS]: 'CY',
  [COUNTRY_NAME.CZECH_REPUBLIC]: 'CZ',
  [COUNTRY_NAME.DENMARK]: 'DK',
  [COUNTRY_NAME.DJIBOUTI]: 'DJ',
  [COUNTRY_NAME.DOMINICA]: 'DM',
  [COUNTRY_NAME.DOMINICAN_REPUBLIC]: 'DO',
  [COUNTRY_NAME.DUTCH_CARIBBEAN]: 'BQ',
  [COUNTRY_NAME.EAST_TIMOR]: 'TL',
  [COUNTRY_NAME.ECUADOR]: 'EC',
  [COUNTRY_NAME.EGYPT]: 'EG',
  [COUNTRY_NAME.EL_SALVADOR]: 'SV',
  [COUNTRY_NAME.ENGLAND]: 'GB',
  [COUNTRY_NAME.EQUATORIAL_GUINEA]: 'GQ',
  [COUNTRY_NAME.ERITREA]: 'ER',
  [COUNTRY_NAME.ESTONIA]: 'EE',
  [COUNTRY_NAME.ETHIOPIA]: 'ET',
  [COUNTRY_NAME.FALKLAND_ISLANDS]: 'FK',
  [COUNTRY_NAME.FAROE_ISLANDS]: 'FO',
  [COUNTRY_NAME.FIJI]: 'FJ',
  [COUNTRY_NAME.FINLAND]: 'FI',
  [COUNTRY_NAME.FRANCE]: 'FR',
  [COUNTRY_NAME.FRENCH_GUIANA]: 'GF',
  [COUNTRY_NAME.FRENCH_POLYNESIA]: 'PF',
  [COUNTRY_NAME.FR_S_TERRITORY]: 'TF',
  [COUNTRY_NAME.GABON]: 'GA',
  [COUNTRY_NAME.GAMBIA]: 'GM',
  [COUNTRY_NAME.GAZA]: 'IL',
  [COUNTRY_NAME.GEORGIA]: 'GE',
  [COUNTRY_NAME.GEORGIA_SANDWICH]: 'GS',
  [COUNTRY_NAME.GERMANY]: 'DE',
  [COUNTRY_NAME.GHANA]: 'GH',
  [COUNTRY_NAME.GIBRALTAR]: 'GI',
  [COUNTRY_NAME.GREAT_BRITAIN]: 'GB',
  [COUNTRY_NAME.GREECE]: 'GR',
  [COUNTRY_NAME.GREENLAND]: 'GL',
  [COUNTRY_NAME.GRENADA]: 'GD',
  [COUNTRY_NAME.GUADELOUPE]: 'GP',
  [COUNTRY_NAME.GUAM]: 'USGU',
  [COUNTRY_NAME.GUATEMALA]: 'GT',
  [COUNTRY_NAME.GUERNSEY]: 'GG',
  [COUNTRY_NAME.GUINEA]: 'GN',
  [COUNTRY_NAME.GUINEA_BISSAU]: 'GW',
  [COUNTRY_NAME.GUYANA]: 'GY',
  [COUNTRY_NAME.HAITI]: 'HT',
  [COUNTRY_NAME.HEARD_MC_DONALD]: 'HM',
  [COUNTRY_NAME.HOLLAND]: 'NL',
  [COUNTRY_NAME.HOLY_SEE]: 'VA',
  [COUNTRY_NAME.HONDURAS]: 'HN',
  [COUNTRY_NAME.HONG_KONG]: 'HK',
  [COUNTRY_NAME.HUNGARY]: 'HU',
  [COUNTRY_NAME.ICELAND]: 'IS',
  [COUNTRY_NAME.INDIA]: 'IN',
  [COUNTRY_NAME.INDONESIA]: 'ID',
  [COUNTRY_NAME.IRAN]: 'IR',
  [COUNTRY_NAME.IRAQ]: 'IQ',
  [COUNTRY_NAME.IRELAND]: 'IE',
  [COUNTRY_NAME.ISLE_OF_MAN]: 'IM',
  [COUNTRY_NAME.ISRAEL]: 'IL',
  [COUNTRY_NAME.ITALY]: 'IT',
  [COUNTRY_NAME.JAMAICA]: 'JM',
  [COUNTRY_NAME.JAPAN]: 'JP',
  [COUNTRY_NAME.JERSEY]: 'JE',
  [COUNTRY_NAME.JORDAN]: 'JO',
  [COUNTRY_NAME.KAZAKHSTAN]: 'KZ',
  [COUNTRY_NAME.KEELING_ISLANDS]: 'CC',
  [COUNTRY_NAME.KENYA]: 'KE',
  [COUNTRY_NAME.KIRIBATI]: 'KI',
  [COUNTRY_NAME.KOREA]: 'KR',
  [COUNTRY_NAME.KOREA_DEM_REP]: 'KP',
  [COUNTRY_NAME.KOSOVA]: 'XZ',
  [COUNTRY_NAME.KOSOVO]: 'XZ',
  [COUNTRY_NAME.KUWAIT]: 'KW',
  [COUNTRY_NAME.KYRGYZSTAN]: 'KG',
  [COUNTRY_NAME.LAOS]: 'LA',
  [COUNTRY_NAME.LATVIA]: 'LV',
  [COUNTRY_NAME.LEBANON]: 'LB',
  [COUNTRY_NAME.LESOTHO]: 'LS',
  [COUNTRY_NAME.LIBERIA]: 'LR',
  [COUNTRY_NAME.LIBYA]: 'LY',
  [COUNTRY_NAME.LIECHTENSTEIN]: 'LI',
  [COUNTRY_NAME.LITHUANIA]: 'LT',
  [COUNTRY_NAME.LUXEMBOURG]: 'LU',
  [COUNTRY_NAME.MACAU]: 'MO',
  [COUNTRY_NAME.MACEDONIA]: 'MK',
  [COUNTRY_NAME.MADAGASCAR]: 'MG',
  [COUNTRY_NAME.MADIERA]: 'PT',
  [COUNTRY_NAME.MALAWI]: 'MW',
  [COUNTRY_NAME.MALAYSIA]: 'MY',
  [COUNTRY_NAME.MALDIVES]: 'MV',
  [COUNTRY_NAME.MALI]: 'ML',
  [COUNTRY_NAME.MALTA]: 'MT',
  [COUNTRY_NAME.MALVINAS]: 'FK',
  [COUNTRY_NAME.MARSHALL_ISLNDS]: 'USMH',
  [COUNTRY_NAME.MARTINIQUE]: 'MQ',
  [COUNTRY_NAME.MAURITANIA]: 'MR',
  [COUNTRY_NAME.MAURITIUS]: 'MU',
  [COUNTRY_NAME.MAYOTTE]: 'YT',
  [COUNTRY_NAME.MEXICO]: 'MX',
  [COUNTRY_NAME.MICRONESIA]: 'USFM',
  [COUNTRY_NAME.MOLDOVA]: 'MD',
  [COUNTRY_NAME.MONACO]: 'MC',
  [COUNTRY_NAME.MONGOLIA]: 'MN',
  [COUNTRY_NAME.MONTENEGRO]: 'ME',
  [COUNTRY_NAME.MONTSERRAT]: 'MS',
  [COUNTRY_NAME.MOROCCO]: 'MA',
  [COUNTRY_NAME.MOZAMBIQUE]: 'MZ',
  [COUNTRY_NAME.MYANMAR]: 'MM',
  [COUNTRY_NAME.NAMIBIA]: 'NA',
  [COUNTRY_NAME.NAURU]: 'NR',
  [COUNTRY_NAME.NEPAL]: 'NP',
  [COUNTRY_NAME.NETHERLANDS]: 'NL',
  [COUNTRY_NAME.NEW_CALEDONIA]: 'NC',
  [COUNTRY_NAME.NEW_ZEALAND]: 'NZ',
  [COUNTRY_NAME.NICARAGUA]: 'NI',
  [COUNTRY_NAME.NIGER]: 'NE',
  [COUNTRY_NAME.NIGERIA]: 'NG',
  [COUNTRY_NAME.NIUE]: 'NU',
  [COUNTRY_NAME.NORFOLK_ISLAND]: 'NF',
  [COUNTRY_NAME.NORTHERN_IRELAND]: 'GB',
  [COUNTRY_NAME.NORTH_KOREA]: 'KP',
  [COUNTRY_NAME.NORWAY]: 'NO',
  [COUNTRY_NAME.N_MARIANA_ISLAND]: 'USMP',
  [COUNTRY_NAME.OMAN]: 'OM',
  [COUNTRY_NAME.PAKISTAN]: 'PK',
  [COUNTRY_NAME.PALAU]: 'USPW',
  [COUNTRY_NAME.PALESTINE]: 'PS',
  [COUNTRY_NAME.PANAMA]: 'PA',
  [COUNTRY_NAME.PAPUA_N_GUINEA]: 'PG',
  [COUNTRY_NAME.PARAGUAY]: 'PY',
  [COUNTRY_NAME.PERU]: 'PE',
  [COUNTRY_NAME.PHILIPPINES]: 'PH',
  [COUNTRY_NAME.PITCAIRN]: 'PN',
  [COUNTRY_NAME.POLAND]: 'PL',
  [COUNTRY_NAME.PORTUGAL]: 'PT',
  [COUNTRY_NAME.PRINCIPE]: 'ST',
  [COUNTRY_NAME.PUERTO_RICO]: 'USPR',
  [COUNTRY_NAME.QATAR]: 'QA',
  [COUNTRY_NAME.REUNION]: 'RE',
  [COUNTRY_NAME.ROMANIA]: 'RO',
  [COUNTRY_NAME.RUSSIA]: 'RU',
  [COUNTRY_NAME.RWANDA]: 'RW',
  [COUNTRY_NAME.SABA]: 'BQ',
  [COUNTRY_NAME.SAINT_HELENA]: 'SH',
  [COUNTRY_NAME.SAINT_LUCIA]: 'LC',
  [COUNTRY_NAME.SAINT_MARTIN]: 'MF',
  [COUNTRY_NAME.SAMOA]: 'WS',
  [COUNTRY_NAME.SAN_MARINO]: 'SM',
  [COUNTRY_NAME.SAUDI_ARABIA]: 'SA',
  [COUNTRY_NAME.SCOTLAND]: 'GB',
  [COUNTRY_NAME.SENEGAL]: 'SN',
  [COUNTRY_NAME.SERBIA]: 'RS',
  [COUNTRY_NAME.SEYCHELLES]: 'SC',
  [COUNTRY_NAME.SICILY]: 'IT',
  [COUNTRY_NAME.SIERRA_LEONE]: 'SL',
  [COUNTRY_NAME.SINGAPORE]: 'SG',
  [COUNTRY_NAME.SINT_EUSTATIUS]: 'BQ',
  [COUNTRY_NAME.SINT_MAARTEN]: 'SX',
  [COUNTRY_NAME.SLOVAKIA]: 'SK',
  [COUNTRY_NAME.SLOVENIA]: 'SI',
  [COUNTRY_NAME.SOLOMON_ISLANDS]: 'SB',
  [COUNTRY_NAME.SOMALIA]: 'SO',
  [COUNTRY_NAME.SOUTH_AFRICA]: 'ZA',
  [COUNTRY_NAME.SOUTH_KOREA]: 'KR',
  [COUNTRY_NAME.SOUTH_SUDAN]: 'SS',
  [COUNTRY_NAME.SPAIN]: 'ES',
  [COUNTRY_NAME.SPANISH_NORTH_AFRICAN_TERR]: 'ES',
  [COUNTRY_NAME.SRI_LANKA]: 'LK',
  [COUNTRY_NAME.ST_BARTHELEMY]: 'BL',
  [COUNTRY_NAME.ST_CROIX]: 'VI',
  [COUNTRY_NAME.ST_KITTS_NEVIS]: 'KN',
  [COUNTRY_NAME.ST_PIERRE_MIQ]: 'PM',
  [COUNTRY_NAME.ST_THOMAS]: 'VI',
  [COUNTRY_NAME.ST_VINCENT_GREN]: 'VC',
  [COUNTRY_NAME.SUDAN]: 'SD',
  [COUNTRY_NAME.SURICOUNTRY_NAME]: 'SR',
  [COUNTRY_NAME.SVALBARD]: 'SJ',
  [COUNTRY_NAME.SWAZILAND]: 'SZ',
  [COUNTRY_NAME.SWEDEN]: 'SE',
  [COUNTRY_NAME.SWITZERLAND]: 'CH',
  [COUNTRY_NAME.SYRIA]: 'SY',
  [COUNTRY_NAME.S_TOME_PRINCIPE]: 'ST',
  [COUNTRY_NAME.TAIWAN]: 'TW',
  [COUNTRY_NAME.TAJIKSTAN]: 'TJ',
  [COUNTRY_NAME.TANZANIA]: 'TZ',
  [COUNTRY_NAME.THAILAND]: 'TH',
  [COUNTRY_NAME.TIBET]: 'CN',
  [COUNTRY_NAME.TIMOR_LESTE]: 'TL',
  [COUNTRY_NAME.TOGO]: 'TG',
  [COUNTRY_NAME.TOKELAU]: 'TK',
  [COUNTRY_NAME.TONGA]: 'TO',
  [COUNTRY_NAME.TORTOLA]: 'VG',
  [COUNTRY_NAME.TRINIDAD_TOBAGO]: 'TT',
  [COUNTRY_NAME.TRISTAN_DA_CUNH]: 'TA',
  [COUNTRY_NAME.TUNISIA]: 'TN',
  [COUNTRY_NAME.TURKEY]: 'TR',
  [COUNTRY_NAME.TURKMENISTAN]: 'TM',
  [COUNTRY_NAME.TURKS_CAICOS]: 'TC',
  [COUNTRY_NAME.TUVALU]: 'TV',
  [COUNTRY_NAME.UGANDA]: 'UG',
  [COUNTRY_NAME.UKRAINE]: 'UA',
  [COUNTRY_NAME.UNITED_ARAB_EMR]: 'AE',
  [COUNTRY_NAME.UNITED_KINGDOM]: 'GB',
  [COUNTRY_NAME.UNITED_STATES]: 'US',
  [COUNTRY_NAME.URUGUAY]: 'UY',
  [COUNTRY_NAME.US_MINOR_ISLNDS]: 'USUM',
  [COUNTRY_NAME.US_VIRGIN_ISL]: 'USVI',
  [COUNTRY_NAME.UZBEKISTAN]: 'UZ',
  [COUNTRY_NAME.VANUATU]: 'VU',
  [COUNTRY_NAME.VATICAN]: 'VA',
  [COUNTRY_NAME.VENEZUELA]: 'VE',
  [COUNTRY_NAME.VIETNAM]: 'VN',
  [COUNTRY_NAME.WALES]: 'GB',
  [COUNTRY_NAME.WALLIS_FUTUNA]: 'WF',
  [COUNTRY_NAME.WESTERN_SAHARA]: 'EH',
  [COUNTRY_NAME.WESTERN_SAMOA]: 'WS',
  [COUNTRY_NAME.YEMEN]: 'YE',
  [COUNTRY_NAME.ZAIRE]: 'CD',
  [COUNTRY_NAME.ZAMBIA]: 'ZM',
  [COUNTRY_NAME.ZIMBABWE]: 'ZW'
}

const CODE_TO_OMIT = [
  COUNTRY_NAME.CANARY_ISLANDS,
  COUNTRY_NAME.SPANISH_NORTH_AFRICAN_TERR,
  COUNTRY_NAME.BALEARIC_ISLANDS,
  COUNTRY_NAME.ENGLAND,
  COUNTRY_NAME.NORTHERN_IRELAND
]
/**
 * A mapping of country code to
 * @param  {string} CODE
 * @returns {string}
 */
const COUNTRY_CODE_TO_COUNTRY_NAME = invertObjectUtil(
  omitObjectUtil(COUNTRY_CODE, CODE_TO_OMIT)
)

export {
  COUNTRY_CODE,
  COUNTRY_CODE_TO_COUNTRY_NAME
}
